import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    fetchBulkNotificationList,
    updateApprovalNoti,

  } from "@/services/approvalNotificationBulk";

  @Module({
    namespaced: true
  })
  export default class approvalNotificationBulk extends VuexModule {
     // state
     bulkNotificationListData = [];
     approvalAcceptRejectData = [];

     // Action  
     @Action
     public async fetchBulkNotificationList(payload) {
       try {
         const data = await fetchBulkNotificationList(payload);
         this.context.commit("setFetchBulkNotificationList", data.data);
         return data;
       } catch (error) {
         throw error;
       }
     }
     @Action
     public async updateApprovalNoti(payload) {
      try {
        const data = await updateApprovalNoti(payload);
        this.context.commit("setUpdateApprovalNoti", data.data);
        return data;
      } catch (error) {
        throw error;
      }
    }

   
     //Mutations
     @Mutation
     public setFetchBulkNotificationList (data: any) {
       this.bulkNotificationListData = data;
     }
     @Mutation
     public setUpdateApprovalNoti (data: any) {
      this.approvalAcceptRejectData = data;
    }
   
     //Getters
     get GetFetchBulkNotificationList() {
        return this. bulkNotificationListData;
      }
     get GetUpdateApprovalNoti() {
        return this.approvalAcceptRejectData;
      }
   
  }